import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import Modal from './modal'
import { ucFirst } from './filter'
import ButtonArrow from './arrowBtn'
import Application from './application'
import { useOffers } from './offersContext'

export default function OfferModal({ offer }) {
  const [show, setShow] = useState(false)

  const { tab, setTab } = useOffers()

  const backToContent = () => {
    setTab('content')
  }

  const updateTab = tabName => setTab(tabName)

  const handleClick = e => {
    e.preventDefault()
    setShow(true)
  }

  const ModalHeader = () => (
    <Fragment>
      {tab !== 'content' && (
        <button className='back_button' onClick={backToContent}>
          <svg
            width='24'
            height='24'
            xmlns='http://www.w3.org/2000/svg'
            fillRule='evenodd'
            clipRule='evenodd'
            fill='#bd9973'
          >
            <path d='M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z' />
          </svg>
        </button>
      )}

      <h3>{offer.title}</h3>

      <ul className='_subtitle'>
        <li className='flex-container align-middle vacancies__city vacancies__details-item'>
          <span
            className='vacancies__icon'
            style={{
              backgroundImage:
                'url(https://globaljet.aero/themes/custom/globaljet/images/marker.svg)',
            }}
          ></span>
          {ucFirst(offer.city)}
        </li>
        <li className='flex-container align-middle vacancies__city vacancies__details-item'>
          <span
            className='vacancies__icon'
            style={{
              backgroundImage:
                'url(https://globaljet.aero/themes/custom/globaljet/images/time.svg)',
            }}
          ></span>

          {ucFirst(offer.employment_type_code)}
        </li>
      </ul>
    </Fragment>
  )

  return (
    <Fragment>
      <div className='flex-container vacancies__link'>
        <ButtonArrow onClick={handleClick}>More details</ButtonArrow>
      </div>

      <Modal
        onClose={() => updateTab('content')}
        header={<ModalHeader />}
        title={offer.title}
        {...{ show, setShow }}
      >
        {tab === 'content' ? (
          <div>
            <h3>Job description</h3>
            <div
              className='modal_desc'
              style={{ color: '#b3b4b8', marginBottom: '12px' }}
              dangerouslySetInnerHTML={{ __html: offer.sharing_description }}
            />
            <h3>Job requirements</h3>
            <div
              className='modal_desc'
              dangerouslySetInnerHTML={{ __html: offer.requirements }}
            />
            <div className='mt-2 flex justify-center'>
              <ButtonArrow onClick={() => updateTab('application')}>
                Submit your application
              </ButtonArrow>
            </div>
          </div>
        ) : (
          <Application {...{ offer }} />
        )}
      </Modal>
    </Fragment>
  )
}

OfferModal.propTypes = {
  offer: PropTypes.object,
}
